
import { useNavigate } from 'react-router-dom';
import { useToast } from "@/hooks/use-toast";
import { supabase } from '@/integrations/supabase/client';
import { SavedState, MatchData } from '@/components/team-details/types/selector-types';
import { useQueryClient } from '@tanstack/react-query';

export const useStateHandlers = (refetch: () => Promise<any>) => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const handleLoadState = async (state: SavedState) => {
    try {
      console.log('Loading state data:', state.data);
      navigate('/data', { 
        state: { 
          data: state.data as MatchData[],
          type: 'dataTable'
        },
        replace: true
      });
      
      toast({
        title: "Success",
        description: "Data loaded successfully",
      });
    } catch (error) {
      console.error('Error loading state:', error);
      toast({
        title: "Error",
        description: "Failed to load data",
        variant: "destructive",
      });
    }
  };

  const handleLoadLeagueTable = (state: SavedState) => {
    console.log('Loading league table data:', state.data);
    navigate('/data', { 
      state: { 
        data: state.data as MatchData[],
        type: 'leagueTable',
        selectedCountry: state.country,
        selectedLeague: state.league,
        selectedYear: state.year
      },
      replace: true
    });
    
    toast({
      title: "Success",
      description: "League table loaded successfully",
    });
  };

  const handleDeleteState = async (id: number) => {
    try {
      console.log('Deleting state with ID:', id);
      
      const { error } = await supabase
        .from('saved_states')
        .delete()
        .eq('id', id);

      if (error) {
        console.error('Error deleting state:', error);
        throw error;
      }

      await queryClient.invalidateQueries({ queryKey: ['saved-states'] });
      await refetch();

      toast({
        title: "Success",
        description: "State deleted successfully",
      });
    } catch (error) {
      console.error('Error deleting state:', error);
      toast({
        title: "Error",
        description: "Failed to delete state",
        variant: "destructive",
      });
    }
  };

  return {
    handleLoadState,
    handleLoadLeagueTable,
    handleDeleteState
  };
};
